module.exports = __webpack_public_path__ + "img/红茶移动微信二维码.f13bef5f.jpg";